import React from "react";

const Section = ({ cssStyle = "section", children }) => {
  return <section className={cssStyle}>{children}</section>;
};

export default Section;
